/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class PetitionsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Record a mission share
     * @param poll_id 
     * @param id 
     * @param body 
     */
    public recordMissionShare(poll_id?: string, id?: string, body?: models.ApiPostPollsPollIdMissionsIdShares, __unused?: any): Observable<models.ApiPetitionMission> {
        const path = '/polls/{poll_id}/missions/{id}/shares'
                    .replace('{' + 'poll_id' + '}', String(poll_id))
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiPetitionMission>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Get a specific mission by id
     * @param poll_id 
     * @param id 
     */
    public getMission(poll_id?: string, id?: string, __unused?: any): Observable<models.ApiPetitionMission> {
        const path = '/polls/{poll_id}/missions/{id}'
                    .replace('{' + 'poll_id' + '}', String(poll_id))
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiPetitionMission>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get petition missions leaderboard
     */
    public getMissionLeaderboard(__unused?: any): Observable<PagedArray<models.ApiPetitionMissionRank>> {
        const path = '/polls/missions/leaderboard';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiPetitionMissionRank>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
